// Copyright (c) 2017 Deere & Company

import AuditCount from '@deere/cps-it.warranty-model-factory/lib/audit-count';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAuditCount = (state, action) =>
    AuditCount.update(state, {
        $merge: action.data
    });

export default (state = getDefaultState().auditCount, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_COUNT]: updateAuditCount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/audit-count.js